module.exports = __webpack_public_path__ + "8cdc5550f2a4d4827a2bdf9095bd8fac.MP3";